// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"9f074c3d","902":"a2e5c6f7"}[chunkId] + ".chunk.js";
};